import './App.css';

/**
 * Calculates and displays longevity increase information based on the employee's appointed date and years of service.
 * 
 * @param {Object} props - The component props.
 * @param {string|Date} props.appointedDate - The date when the employee was appointed.
 * @param {number} props.longevity - The number of years the employee has been in service.
 * @returns {JSX.Element} A div element containing a header with longevity increase information.
 */
function LongevityDate(props) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  let appointedDate = new Date(props.appointedDate);
  let currentDate = new Date();
  let longevity = props.longevity;
  let yearsTillL5 = (4 - Math.floor(longevity));
  let nextLongevityDate = new Date(appointedDate).setFullYear(currentDate.getFullYear() + yearsTillL5);
  let step;
  let code;
  let content;

  // If longevity is less than 5
  if(props.jobTitle === 'occupational-therapist' || props.jobTitle === 'physical-therapist' || props.jobTitle === 'audiologist'){
    const oneYearAfterAppointment = new Date(appointedDate);
    oneYearAfterAppointment.setFullYear(appointedDate.getFullYear() + 1);

    const anniversaryYear = oneYearAfterAppointment.getFullYear();
    let nextJan1st = new Date(anniversaryYear, 0, 1);
    if (oneYearAfterAppointment >= nextJan1st) {
        nextJan1st.setFullYear(anniversaryYear + 1);
    }
    let nextJuly1st = new Date(anniversaryYear, 6, 1);
    if (oneYearAfterAppointment >= nextJuly1st) {
        nextJuly1st.setFullYear(anniversaryYear + 1);
    }
    const firstLongevityDate = nextJan1st < nextJuly1st ? nextJan1st : nextJuly1st;
    const secondLongevityDate = new Date(firstLongevityDate);
    secondLongevityDate.setFullYear(secondLongevityDate.getFullYear() + 1);
    if(currentDate < firstLongevityDate){
        longevity = 0;
        nextLongevityDate = firstLongevityDate;
    }
    else if(currentDate < secondLongevityDate){
        longevity = 1;
        nextLongevityDate = secondLongevityDate;
    }
  }
  if(props.longevity < 5 && (props.jobTitle != 'occupational-therapist' && props.jobTitle != 'physical-therapist' && props.jobTitle != 'audiologist')) {
    content = "You will reach your first longevity increase on <strong>" + new Date(nextLongevityDate).toLocaleDateString("en-US", options) + ".</strong>";
  }
  else if(longevity === 0 && (props.jobTitle === 'occupational-therapist' || props.jobTitle === 'physical-therapist' || props.jobTitle === 'audiologist')){
    content = "You will reach your first longevity increase on <strong>" + new Date(nextLongevityDate).toLocaleDateString("en-US", options) + ".</strong>";
  }
  // Else If longevity is grater than or equal to 22
  else if(props.longevity >= 22 || (props.longevity >= 15 && props.jobTitle == "paraprofessionals")) {
    content = "You have reached the highest longevity increase.";
  }
  else{
    if(props.jobTitle == "paraprofessionals"){
      if(longevity >= 5){
        step = "first"
        code = "L5 (five years)";
      }
    }
    else if (props.jobTitle === 'staff-nurse' || props.jobTitle === 'head-nurse' || props.jobTitle === 'supervisor-nurse'){
      if(longevity >= 5){
        step = "first"
        code = "(5 but less than 7)";
      }
      if(longevity >= 7){
        step = "second";
        code = "(7 but less than 10)";
      }
      if(longevity >= 10){
        step = "third";
        code = "(10 but less than 15)";
      }
      if(longevity >= 15){
        step = "fourth";
        code = "(15 but less than 20)";
      }
      if(longevity >= 20){
        step = "fifth";
        code = "(20 but less than 22)";
      }
      if(longevity >= 22){
        step = "sixth";
        code = "(22 years or more)";
      }
    }
    else if (props.jobTitle === 'occupational-therapist' || props.jobTitle === 'physical-therapist' || props.jobTitle === 'audiologist'){
      if(longevity >= 1){
        step = "first"
        code = "(A/B first year)";
      }
      if(longevity >= 2){
        step = "second";
        code = "(A/B)";
      }
      if(longevity >= 5){
        step = "third"
        code = "(A/B + 5 but less than 7)";
      }
      if(longevity >= 7){
        step = "fourth";
        code = "(A/B + 7 but less than 10)";
      }
      if(longevity >= 10){
        step = "fifth";
        code = "(A/B + 10 but less than 15)";
      }
      if(longevity >= 15){
        step = "sixth";
        code = "(A/B + 15 but less than 20)";
      }
      if(longevity >= 20){
        step = "seventh";
        code = "(A/B + 20 but less than 22)";
      }
      if(longevity >= 22){
        step = "eighth";
        code = "(A/B + 22 years or more)";
      }
    }
    else{
      if(longevity >= 5){
        step = "first"
        code = "L5 (five years)";
      }
      if(longevity >= 10){
        step = "second";
        code = "L10 (ten years)";
      }
      if(longevity >= 13){
        step = "third";
        code = "L13 (thirteen years)";
      }
      if(longevity >= 15){
        step = "fourth";
        code = "L15 (fifteen years)";
      }
      if(longevity >= 18){
        step = "fifth";
        code = "L18 (eighteen years)";
      }
      if(longevity >= 20){
        step = "sixth";
        code = "L20 (twenty years)";
      }
    }
    content = "You have reached your " + step + " longevity increase, " + code + ".";
  }
  
  return (
    <>
        <div className="longevity-date">
            <h2 className='sub-title' dangerouslySetInnerHTML={{__html: content}}></h2>
        </div>
    </>
  );
}

export default LongevityDate;